import React from "react";
import { NavLink } from "react-router-dom";
import SectionHeader from "../../utilis/SectionHeader";
import { FaChartPie } from "react-icons/fa";
import { RiUser5Fill } from "react-icons/ri";
import { FaArrowRight } from "react-icons/fa";
import { FaHandHoldingUsd } from "react-icons/fa";
import { MdNotificationsActive } from "react-icons/md";

const ExchangeSection = () => {
  const content = [
    {
      icon: <FaHandHoldingUsd />,
      title: "Money Transfer",
      content:
        "Lorem ipsum dolor sit amet ametus conso tetur ading elitor fugit piatur iusto provid.",
        link : 'send money',
    },
    {
      icon: <FaChartPie />,
      title: "Currency Chart",
      content:
        "Lorem ipsum dolor sit amet ametus conso tetur ading elitor fugit piatur iusto provid.",
        link : 'view chart',
    },
    {
      icon: <MdNotificationsActive />,
      title: "Rate Alerts",
      content:
        "Lorem ipsum dolor sit amet ametus conso tetur ading elitor fugit piatur iusto provid.",
        link : 'create alerts',

    },
    {
      icon: <RiUser5Fill />,
      title: "Create Account",
      content:
        "Lorem ipsum dolor sit amet ametus conso tetur ading elitor fugit piatur iusto provid.",
        link : 'get started',
    },
  ];

  return (
    <div className="exchange_section section-padding padding-bottom">
      <div className="container px-sm-0 px-4">
        {/* HEADING SECTION */}
        <div className="row padding-bottom">
          <div className="col-lg-6 col-sm-10 mx-auto" data-aos='zoom-in' >
            <SectionHeader
              subTitle="MOST POPULAR CURRENCY TOOLS"
              title="Set Up & Exchange Money From Your Cards In A Minute"
            />
          </div>
        </div>
        {/* CONTENT SECTION */}
        <div className="row">
          {content.map((element, index) => {
            return (
              <div className="col-lg-4 col-xl-3 col-sm-6  mb-4 mb-lg-1" key={index} data-aos='fade-up' >
                <div className="exhange_card shadow">
                  <div className="">
                    <p className="exchange_img">{element.icon}</p>
                  </div>
                  <div className="exhange_content mt-sm-5 mt-4">
                    <h5 className="my-4  text-black fw-800">{element.title}</h5>
                    <p className="text-color text-justify-left">{element.content}</p>
                    <NavLink to='/converter' className='exchange_link text-capitalize fw-600' >{element.link} <span className="ms-2"><FaArrowRight /></span> </NavLink>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ExchangeSection;
